import { useQuery } from "@tanstack/react-query";

import * as subscriptionApi from "@core/apis/subscription.api";
import type { CommonUseQueryOptions } from "@core/types/app";
import type { Subscription } from "@core/types/subscription";
import queryKeyGenerator from "@core/utils/queryKeyGenerator";

export default (options?: CommonUseQueryOptions<Subscription | null>) => {
  const query = useQuery({
    ...options,
    queryKey: queryKeyGenerator.getSubscription(),
    queryFn: () => subscriptionApi.getSubscription(),
  });

  return query;
};
